export const API = {
  auth: {
    me: '/auth/me',
    login: '/auth/login',
    refresh: '/auth/refresh',
  },
  N033: {
    createAffiliate: (id: number) => `/N033/affiliates/${id}`,
    toggleAffiliate: (id: number) => `/N033/enable/${id}`,
  },
} as const;
